import { v4 as createId } from 'uuid';
import { Language, LanguageAwareString } from '../../../../Typescript/classes';
import { ProgramBuilderQuestionInstance } from '../../../FormManager/classes';
import type { QuoteComponentProps } from '../types';

const createRequiredComponent = (
  apiName: string,
  label: string,
): ProgramBuilderQuestionInstance => {
  return new ProgramBuilderQuestionInstance({
    clientId: createId(),
    apiName,
    displayNames: [new LanguageAwareString(apiName, Language.english)],
    component: 'textfield',
    labels: [new LanguageAwareString(label, Language.english)],
    dataType: 'string',
    propsBlob: {},
    subQuestions: [],
  });
};

export const requiredComponents = [
  createRequiredComponent('address', 'Address'),
  createRequiredComponent('city', 'City'),
  createRequiredComponent('province', 'Province'),
  createRequiredComponent('postal', 'Postal Code'),
];

export function findRequiredSubQuestion(
  questionInstance: QuoteComponentProps['questionInstance'],
  apiName: string,
) {
  const subQuestion = questionInstance.subQuestions.find(
    (ele) => ele.apiName === apiName,
  );
  if (!subQuestion) {
    throw new Error(
      `Unable to find required field "${apiName}" for question ${JSON.stringify(
        questionInstance,
        null,
        4,
      )}!`,
    );
  }
  return subQuestion;
}
